/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import React from 'react';

// @ts-expect-error
// eslint-disable-next-line unused-imports/no-unused-imports
import CalendarUtil from 'calendar/CalendarUtil';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import FileBrowserUtil from 'file-browser/FileBrowserUtil';
// @ts-expect-error
import FileMenu from 'file-browser/FileMenu';
import FinderUtil from 'file-browser/FinderUtil';
import {setDefaultRegistry} from 'registry/DefaultRegistry';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import ExpandedScrollableTable from 'ui-library/scrollable/ExpandedScrollableTable';
import * as DateUtil from 'util/DateUtil';

interface Props {
  className?: string;
  finderId: string;
  openResult: (...args: Array<any>) => any;
  registries: Array<any>;
  areRegistriesLoading: boolean;
}

/**
 * Table for displaying registries.
 */
class ExpandedProjectTable extends React.Component<Props> {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  _handleOpenRegistry = (row: any) => {
    this.props.openResult(row.extra.rootFolder);
    setDefaultRegistry(row.id);
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  _handleContextMenu = (row: any, e: any) => {
    FileMenu.open(e, {
      file: row.extra.result,
      finderId: this.props.finderId,
      isListing: true,
    });
  };

  render(): JSX.Element {
    if (this.props.areRegistriesLoading) {
      return (
        <div>
          <span className="faded">Loading...</span>
        </div>
      );
    } else if (this.props.registries.length === 0) {
      return (
        <div>
          <span className="faded">None found.</span>
        </div>
      );
    }
    const columns = [
      {
        header: 'Name',
        accessorKey: 'name',
        flexGrow: 1,
        isCollapsible: false,
        isSortable: false,
      },
      {
        header: 'Created',
        accessorKey: 'createdAt',
        isCollapsible: false,
        isSortable: false,
      },
      {
        header: 'Description',
        accessorKey: 'description',
        flexGrow: 1,
        isCollapsible: false,
        isSortable: false,
      },
    ];
    const rows = this.props.registries.map((registry) => ({
      id: registry.id,
      data: {
        createdAt: DateUtil.readableTime(registry.createdAt, {showTime: false}),
        name: FileBrowserUtil.getRegistryName(registry),
        description: registry.description,
      },
      icon: <BenchlingIcon className="scrollableTable-cell-icon" icon={ModelTypeConstants.REGISTRY} />,
      extra: {
        result: registry,
        rootFolder: FinderUtil.sourceToRootFolder(registry),
      },
    }));
    return (
      <ExpandedScrollableTable
        className={this.props.className}
        columns={columns}
        isCompact={false}
        matchParentHeight={true}
        onRowClick={this._handleOpenRegistry}
        onRowContextMenu={this._handleContextMenu}
        rows={rows}
      />
    );
  }
}

export default ExpandedProjectTable;
